import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { comics, categories } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeSlug]);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const filteredComics = activeSlug === 'all'
    ? comics
    : comics.filter(c => c.categorySlug === activeSlug);

  const currentCategory = categories.find(c => c.slug === activeSlug);

  return (
    <>
      <SEOHead
        title={`${currentCategory?.name || '全部'}韩漫 - 免费韩国漫画分类浏览 - 奇漫屋`}
        description={`奇漫屋${currentCategory?.name || '全部'}分类韩国漫画，在线免费阅读，支持下拉式浏览，最新${currentCategory?.name || ''}韩漫资源持续更新。`}
        keywords={`${currentCategory?.name || ''}韩漫, 韩国漫画, 在线漫画, 免费韩漫, 奇漫屋`}
        canonicalUrl={`https://qimanwu.com/category/${activeSlug}`}
      />
      <SchemaOrg
        type="WebPage"
        pageUrl={`https://qimanwu.com/category/${activeSlug}`}
        pageName={`${currentCategory?.name || '全部'}韩漫 - 奇漫屋`}
      />
      <SchemaOrg
        type="BreadcrumbList"
        breadcrumbItems={[
          { name: '首页', url: 'https://qimanwu.com' },
          { name: '漫画分类', url: 'https://qimanwu.com/category/all' },
          { name: currentCategory?.name || '全部', url: `https://qimanwu.com/category/${activeSlug}` },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb />

          <section className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                {currentCategory?.name || '全部'}韩漫
              </h1>
              <p className="text-sm text-foreground-500">
                发现精彩的{(currentCategory?.name || '韩国')}漫画，共 {filteredComics.length} 部作品
              </p>
            </div>

            <div className="flex items-center gap-2 overflow-x-auto pb-4 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => {
                    setActiveSlug(cat.slug);
                    window.scrollTo(0, 0);
                  }}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-xs`}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
                {filteredComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-emotion-sad-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画，请浏览其他分类</p>
              </div>
            )}
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}